import Vue from 'vue';
import { VLazy, VToolbar } from 'vuetify/lib'

export default Vue.extend({
  mixins: [VLazy],
  methods: {
    onObserve (
      entries,
      observer,
      isIntersecting,
    ) {
      this.isActive = isIntersecting || this.isActive
      this.$emit('is-visible', isIntersecting)
    },
  },
})